/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserIdsSearchRequest} from '../models/UserIdsSearchRequest';
import type {UserSavedSearch} from '../models/UserSavedSearch';
import type {UserSearchRequest} from '../models/UserSearchRequest';
import type {UserSearchResponse} from '../models/UserSearchResponse';

export interface GetUsersActivities$Request {
    requestBody: Array<number>;
}

export interface GetUsersActivities$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersActivitiesRequest = createAction<PayloadData<void, GetUsersActivities$Request>>('USER_SEARCH__GET_USERS_ACTIVITIES__REQUEST');
export const getUsersActivitiesSuccess = createAction<PayloadData<{ [key: string]: { [key: string]: string; }; }, GetUsersActivities$Request>>('USER_SEARCH__GET_USERS_ACTIVITIES__SUCCESS');
export const getUsersActivitiesFailure = createAction<PayloadData<Error, GetUsersActivities$Request, true>>('USER_SEARCH__GET_USERS_ACTIVITIES__FAILURE');

export const getUsersActivitiesActions = [
    getUsersActivitiesRequest,
    getUsersActivitiesSuccess,
    getUsersActivitiesFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersActivities = (meta: GetUsersActivities$Request, config?: GetUsersActivities$Config) => {
    return {
        CALL_API: {
            types: getUsersActivitiesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/search/last-activities`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersSavedSearches$Request {
    requestBody: Array<number>;
}

export interface GetUsersSavedSearches$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersSavedSearchesRequest = createAction<PayloadData<void, GetUsersSavedSearches$Request>>('USER_SEARCH__GET_USERS_SAVED_SEARCHES__REQUEST');
export const getUsersSavedSearchesSuccess = createAction<PayloadData<{ [key: string]: UserSavedSearch; }, GetUsersSavedSearches$Request>>('USER_SEARCH__GET_USERS_SAVED_SEARCHES__SUCCESS');
export const getUsersSavedSearchesFailure = createAction<PayloadData<Error, GetUsersSavedSearches$Request, true>>('USER_SEARCH__GET_USERS_SAVED_SEARCHES__FAILURE');

export const getUsersSavedSearchesActions = [
    getUsersSavedSearchesRequest,
    getUsersSavedSearchesSuccess,
    getUsersSavedSearchesFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersSavedSearches = (meta: GetUsersSavedSearches$Request, config?: GetUsersSavedSearches$Config) => {
    return {
        CALL_API: {
            types: getUsersSavedSearchesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/search/saved-searches`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RunUserIdsSearch$Request {
    userIdsSearchRequest: UserIdsSearchRequest;
}

export interface RunUserIdsSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runUserIdsSearchRequest = createAction<PayloadData<void, RunUserIdsSearch$Request>>('USER_SEARCH__RUN_USER_IDS_SEARCH__REQUEST');
export const runUserIdsSearchSuccess = createAction<PayloadData<Array<number>, RunUserIdsSearch$Request>>('USER_SEARCH__RUN_USER_IDS_SEARCH__SUCCESS');
export const runUserIdsSearchFailure = createAction<PayloadData<Error, RunUserIdsSearch$Request, true>>('USER_SEARCH__RUN_USER_IDS_SEARCH__FAILURE');

export const runUserIdsSearchActions = [
    runUserIdsSearchRequest,
    runUserIdsSearchSuccess,
    runUserIdsSearchFailure
] as const;

/**
 * @param {UserIdsSearchRequest} meta.userIdsSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runUserIdsSearch = (meta: RunUserIdsSearch$Request, config?: RunUserIdsSearch$Config) => {
    return {
        CALL_API: {
            types: runUserIdsSearchActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/search/ids`,
            TRANSPORT_REQUEST_BODY: meta.userIdsSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RunUserSearch$Request {
    userSearchRequest: UserSearchRequest;
}

export interface RunUserSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runUserSearchRequest = createAction<PayloadData<void, RunUserSearch$Request>>('USER_SEARCH__RUN_USER_SEARCH__REQUEST');
export const runUserSearchSuccess = createAction<PayloadData<UserSearchResponse, RunUserSearch$Request>>('USER_SEARCH__RUN_USER_SEARCH__SUCCESS');
export const runUserSearchFailure = createAction<PayloadData<Error, RunUserSearch$Request, true>>('USER_SEARCH__RUN_USER_SEARCH__FAILURE');

export const runUserSearchActions = [
    runUserSearchRequest,
    runUserSearchSuccess,
    runUserSearchFailure
] as const;

/**
 * @param {UserSearchRequest} meta.userSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runUserSearch = (meta: RunUserSearch$Request, config?: RunUserSearch$Config) => {
    return {
        CALL_API: {
            types: runUserSearchActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/search`,
            TRANSPORT_REQUEST_BODY: meta.userSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

